/* @flow */

import { createSelector } from 'reselect';
import loggiClient from '../loggi/loggiClient';
import { LOJAS } from '../loggi/querys';
import { type State } from '../preact-app/types';
import {
    type Loja,
    type LoggiState,
    type SetLojasAction,
    type SelecionarLojaAction,
    type Action,
} from './loggi-types';
import dialogoCadastroLoggi from '../loggi/dialogoCadastroLoggi';

const SET_LOJAS = 'loggi/SET_LOJAS';
const SELECIONAR_LOJA = 'loggi/SELECIONAR_LOJA';

export const getLoggi = (state: State): LoggiState => state.loggi;
export const getLojas = (state: State): Loja[] => getLoggi(state).lojas;
export const getPk = (state: State): ?number => getLoggi(state).pk;

export const getLojaSelecionada: State => ?Loja = createSelector(
    getPk,
    getLojas,
    (pk, lojas) => (pk ? lojas.find(loja => loja.pk === pk) : null),
);

const setLojas = (lojas: Loja[]): SetLojasAction => ({ lojas, type: SET_LOJAS });
export const selecionarLoja = (pk: number): SelecionarLojaAction => ({ pk, type: SELECIONAR_LOJA });

export const buscarLojas = () => (dispatch: Function) => {
    loggiClient
        .query({ query: LOJAS })
        .then(response => response.data.allShops.edges.map(edge => edge.node))
        .then((lojas) => {
            dispatch(setLojas(lojas));
        });
};

export const cadastrarLoggi = () => (dispatch: Function) => {
    dialogoCadastroLoggi().then(() => dispatch(buscarLojas()));
};

const initialState = {
    lojas: [],
    pk: null,
};

const loggiReducer = (state: LoggiState = initialState, action: Action): LoggiState => {
    switch (action.type) {
    case SET_LOJAS:
        return {
            ...state,
            lojas: action.lojas,
            pk: action.lojas[0].pk,
        };
    case SELECIONAR_LOJA:
        return {
            ...state,
            pk: action.pk,
        };
    default:
        return state;
    }
};

export default loggiReducer;
